module.exports = __webpack_public_path__ + "media/images/recruitment/landing/icon_complete_right-a0c09ff3e20ef0bfd93692d466448bfc.svg";